import { FormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent implements OnInit {

	@Input() form:FormGroup;
	@Input() name:string;
	@Input() label:string = '';
  constructor() { }

  ngOnInit() {
	}
	
	erase(){
		// debugger;
		this.form.controls[this.name].setValue('');
	}

}
